export function sortByDepth (content) {
  let json = JSON.parse(content)

  let nodes = {}

  let allSorted = false
  let nb = 0

  let nbSorted
  while (!allSorted) {
    nbSorted = 0
    for (let key in json) {
      if (typeof json[key].sort === 'undefined' || json[key].sort !== true) {
        if (typeof json[key].parent === 'undefined' || json[key].parent.length === 0) {
          json[key].childs = {}
          nodes[json[key].key] = json[key]
          json[key].sort = true
        } else {
          json[key].sort = addChild(nodes, json[key])
        }
      }
      if (json[key].sort === true) {
        ++nbSorted
      }
    }
    if ((nbSorted) === Object.keys(json).length) {
      allSorted = true
    }
    ++nb
    if (nb === 15) {
      break
    }
  }
  return nodes
}

function addChild (nodes, child) {
  for (let key in nodes) {
    if (key.toString() === child.parent.toString()) {
      if (typeof child.childs === 'undefined') {
        child.childs = {}
      }
      nodes[key].childs[child.key] = child
      return true
    } else if (addChild(nodes[key].childs, child) === true) {
      return true
    }
  }
  return false
}

export function getBibliography (content) {
  let json = JSON.parse(content)
  let bibliography = []

  for (let key in json) {
    let node = json[key]
    if (node.documents) {
      for (let key2 in node.documents) {
        let doc = node.documents[key2]
        if (doc.cite) {
          bibliography.push(doc.cite.charAt(0).toUpperCase() + doc.cite.slice(1))
        } else {
          let authors = doc.authors.replace(';', ',')
          let cite = authors + '. ' + doc.title + '. ' + doc.source + ', Date not specified'
          bibliography.push(cite.charAt(0).toUpperCase() + cite.slice(1))
        }
      }
    }
  }

  bibliography.sort()
  let set = new Set(bibliography)

  return Array.from(set)
}

export function getAiChat (content) {
  let json = JSON.parse(content)
  let technoLockIn = []

  for (let key in json) {
    let node = json[key]
    if (node.documents) {
      for (let key2 in node.documents) {
        let doc = node.documents[key2]
        if (doc.technoLockIn) {
          let authors = doc.authors.split(',')
          let firstAuthor = (authors && authors.length > 0) ? authors[0] + ', ' : authors + ', '

          technoLockIn.push(doc.technoLockIn + '<span class="text-info"> (' + firstAuthor + doc.dt + ')</span>')
        }
      }
    }
  }

  return Array.from(new Set(technoLockIn))
}



// WEBPACK FOOTER //
// ./src/assets/scripts/biblio.js